<template>
  <tg-dialog
    ref="dialog"
    v-bind="{ ...$attrs }"
    v-on="$listeners"
    :visible.sync="visible"
    :show-close="true"
    :title=" username+' '+title"
    :subject="subject"
    :showIcon="false"
    showCancelBtn
    destroy-on-close
    append-to-body
    width="40%"
    @on-confirm="confirmHandler"
  >
    <div style="width: 100%;text-align: left;;margin-bottom: 20px;">
      <span style="text-align: left;">
        <!-- 針對所有賽事盤口 -->
        {{ $t("component.dialog.handicap.tip") }} 
      </span>
    </div>
    <div>
      <el-radio-group v-model="selectedValue" style="display: flex;">
      <template v-for="(item, i) in items">
        <el-radio
          v-if="item.show != false"
          :key="i"
          :label="item.value"
          :name="item.name"
          :border="true"
          :style="{margin:'0px 10px'}"
          size="large"
        >{{ item.name }}
        </el-radio>
      </template>
    </el-radio-group>
    </div>
  </tg-dialog>
</template>

<script>
import TgDialog from "@/components/dialog/TgDialog";

export default {
  inheritAttrs: false,
  components: {
    TgDialog,
  },
  data() {
    return {
      visible: false,
    };
  },
  props: {
    items: Array,
    title: String,
    subject:String,
    subtitle: String,
    selectedValue:Number,
    username:String,
  },
  methods: {
    confirmHandler() {
      this.$emit(
        "confirm",
        this.selectedValue,
        this.username,
      );
    },
    show() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
  },
};
</script>